// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProseMirror {\n  padding: 0.5rem;\n  min-height: 100px;\n}\n.ProseMirror:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  -webkit-box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n          box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);\n}\n", ""]);
// Exports
module.exports = exports;
